import React, {ChangeEvent, Component} from 'react';
import { connect } from 'react-redux';
import { withStyles } from "@material-ui/core";
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import UploadFileIcon from "@mui/icons-material/UploadFile";
import FileSelect from '@mui/icons-material/FileCopy';
import Close from '@mui/icons-material/Close';

import materialFile from '../../../../utils/dataFiles/materialList.txt';
import stlFile from '../../../../utils/dataFiles/stlList.txt';


//-----------------------------------------------------------------



const useStyles = (theme) => ({

    item: {
        width: '100%',
    },

    grid: {
        width: '100%',
        padding: 12
    },

});



//-----------------------------------------------------------------



class STL_Listitem_ extends Component {
    
    static propTypes = {
        indexItem: PropTypes.number,
    };

    static defaultProps = {
        indexItem: 0,
    };

    //Initializes empty STL file without any properties
    constructor(props) {
        super(props);

        this.state = {
            STLFilePath: null,
            material: null,
            color: null,
            materialList: [],
            stlList: [],
        };

    }


    render() {

        const {classes, indexItem} = this.props;
        

        //-------------------------------------------------------------


        const stlFiles = [ "./res/stl/cube.stl", "./res/stl/cylinder.stl", "./res/stl/POM_cube_2_Al_cylinders_CUBE.STL", "./res/stl/POM_cube_2_Al_cylinders_cylinders.STL" ];

        if (this.state.materialList.length == 0) {
            fetch(materialFile)
                .then(r => r.text())
                .then(text => {
                    let arr = text.split("\n");
                    this.setState({materialList: arr});
                    //alert(arr);
                });
        }

        if (this.state.stlList.length == 0) {
            fetch(stlFile)
                .then(r => r.text())
                .then(text => {
                    const arr = text.split("\n");
                    this.setState({stlList: arr});
                    //alert(arr);
                });
        }


        //-------------------------------------------------------------

        //Overwrites old STL file properties with the newly selected one's; used when uploading new STL file
        const handleFileUpload = (e) => {

            if (!e.target.files) {
              return;
            }

            const file = e.target.files[0];
            const url = URL.createObjectURL( file );
                
            this.setState({STLFilePath: file.name});
            this.props.updateItem({index: indexItem, STLFilePath: url, STLFileName: file.name, material:this.props.STL_List_Items[indexItem].material}); 

        };


        //-------------------------------------------------------------


        return (
            //Creates List displaying all uploaded STL files
            <ListItem>
                
                <Paper //New Paper for every item uploaded
                    direction={'row'}
                    elevation={3}
                    className={classes.item}>
                    
                    <Grid //Grid for whole row (Name,Material,X-Button) 
                        container
                        direction={'row'} 
                        alignItems="stretch"
                        justifyContent="space-between"
                        className={classes.grid}>

                        <Grid //Grid for name and material only 
                        container
                        direction={'row'} 
                        alignItems="stretch"
                        justifyContent="space-between"
                        style={{width:'90%'}}>

                            <Button //"Upload STL" Button
                                sx={{width:'68%', textOverflow:"ellipsis", textAlign:"left", overflow:"hidden", whiteSpace:"nowrap"}}
                                component="label"
                                variant="outlined"
                                startIcon={<UploadFileIcon />} >
                                {(this.props.STL_List_Items[indexItem].STLFileName == "") ? "Upload STL" : this.props.STL_List_Items[indexItem].STLFileName}
                                <input type="file" accept=".stl" hidden onChange={handleFileUpload} />
                            </Button>

                            <FormControl //Select Material Dropdown Menu
                                size="small"
                                style={{ width: '30%' }}> 
                                <InputLabel>Material</InputLabel> 
                                <Select 
                                    style={{ backgroundColor: this.props.STL_List_Items[indexItem].color }}
                                    value={this.props.STL_List_Items[indexItem].material}
                                    label="Material"
                                    onChange={(event) => { 
                                        this.setState({material: event.target.value}); //Sets STL file's Material
                                        this.props.updateItem({index: indexItem, STLFilePath: this.props.STL_List_Items[indexItem].STLFilePath, STLFileName: this.props.STL_List_Items[indexItem].STLFileName, material:event.target.value}); 
                                        }}>
                                        { 
                                    
                                            this.state.materialList.map((label, index) => { return ( <MenuItem value={label.replace(/(\r\n|\n|\r)/gm,"")}>{label.replace(/(\r\n|\n|\r)/gm,"")}</MenuItem> ); //Fetches Color from ColorMap in Reducer.js
                                            })
                                        
                                        }
                                </Select>
                            </FormControl>

                        </Grid>

                        <IconButton //X-Button to erase STL File upload
                            color="error" 
                            size='small'
                            onClick={() => { this.props.removeSTLListItem({index: indexItem, STLFilePath: this.state.STLFilePath, material:this.state.material});}}>
                            <Close />
                        </IconButton>

                    </Grid>

                </Paper> 

            </ListItem>

        );

    }

}



//-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

  return {
        STL_List_Items: state.stlColumn.STL_List_Items,
  };

}

const mapDispatchToProps = (dispatch, props) => {

  return {
        updateItem: (val) => { dispatch({ type: "STL_LIST:UPDATE_ITEM", value: val }) },
        removeSTLListItem: (val) => { dispatch({ type: "STL_LIST:REMOVE_ITEM", value: val }) },
  };
  
}


const STL_Listitem = connect(mapStateToProps, mapDispatchToProps)(STL_Listitem_)
export default withStyles(useStyles) (STL_Listitem);
